// Determine API URL based on environment
const API_URL = process.env.NODE_ENV === 'production'
  ? 'https://z0fj5i3uga.execute-api.ap-southeast-2.amazonaws.com/production'
  : 'http://localhost:8080';

let sessionId = null;

// Initialize from URL parameter if present
export const initSession = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const session = urlParams.get('session');
  if (session) {
    sessionId = session;
    // Remove session from URL
    window.history.replaceState({}, document.title, window.location.pathname);
    return true;
  }
  return false;
};

export const getSessionId = () => sessionId;

export const startGoogleAuth = async () => {
  try {
    const response = await fetch(`${API_URL}/auth/google`);
    const data = await response.json();
    window.location.href = data.url;
  } catch (error) {
    console.error('Error starting Google auth:', error);
    throw error;
  }
};

export const getCurrentUser = async () => {
  if (!sessionId) return null;
  
  try {
    const response = await fetch(`${API_URL}/api/user?session=${sessionId}`);
    if (!response.ok) {
      if (response.status === 401) {
        sessionId = null;
      }
      return null;
    }
    const data = await response.json();
    return data.user;
  } catch (error) {
    console.error('Error getting user:', error);
    return null;
  }
};

export const loadData = async () => {
  if (!sessionId) return { words: [], lastAddedDate: null };
  
  try {
    const response = await fetch(`${API_URL}/api/words?session=${sessionId}`);
    if (!response.ok) {
      if (response.status === 401) {
        sessionId = null;
      }
      return { words: [], lastAddedDate: null };
    }
    return await response.json();
  } catch (error) {
    console.error('Error loading data:', error);
    return { words: [], lastAddedDate: null };
  }
};

export const saveData = async (data) => {
  if (!sessionId) throw new Error('Not authenticated');
  
  try {
    const response = await fetch(`${API_URL}/api/words?session=${sessionId}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data)
    });
    
    if (!response.ok) {
      if (response.status === 401) {
        sessionId = null;
      }
      throw new Error('Failed to save data');
    }
    
    return true;
  } catch (error) {
    console.error('Error saving data:', error);
    throw error;
  }
};

export const logout = async () => {
  if (!sessionId) return;
  
  try {
    await fetch(`${API_URL}/api/logout`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ session: sessionId })
    });
  } catch (error) {
    console.error('Error logging out:', error);
  } finally {
    sessionId = null;
  }
}; 